import { type FC } from "react";
import { SegmentedControls } from "../../primitives";
import {
	useFinancialGridDispatch,
	useFinancialGridState,
} from "./state/FinancialGridStateProvider";
import {
	ADMIN_VIEW_OPTIONS,
	type GridViewOption,
	type NonEmptyArray,
	type ViewMode,
} from "./types";

type GridViewToggleProps = {
	viewOptions?: NonEmptyArray<GridViewOption>;
};

export const GridViewToggle: FC<GridViewToggleProps> = ({ viewOptions = ADMIN_VIEW_OPTIONS }) => {
	const { view } = useFinancialGridState();
	const financialDispatch = useFinancialGridDispatch();

	return (
		<SegmentedControls<ViewMode>
			value={view}
			onChange={(nextView) => financialDispatch({ type: "set_view", view: nextView })}
		>
			{viewOptions.map((option) => (
				<SegmentedControls.Segment key={option.id} value={option.id}>
					{option.label}
				</SegmentedControls.Segment>
			))}
		</SegmentedControls>
	);
};
